<template>
  <mu-card>
    <mu-card-header
      :title="title"
      :subTitle="$t('message.foodDiaryLandingExplain')"
      titleClass="mediumTitle"
      class="headerHasBack"
    >
      <mu-icon-button icon="arrow_back" slot="avatar" mini @click.native="goBack()"></mu-icon-button>
    </mu-card-header>
    <mu-divider></mu-divider>
    <mu-content-block style="padding: 16px;">
      <mu-row gutter>
        <mu-col desktop="100" tablet="100" width="100">
          <mu-row gutter style="margin-bottom: 16px">
            <!--<mu-col desktop="50" tablet="50" width="50">
              <mu-paper align="center" class="paperCard">
                <mu-content-block class="landingCard">
                  <mu-flexbox align="center" justify="center" style="height: 100%">
                    <mu-flexbox-item align="center">
                      <img style="height: 58px" src="static/food-diary/barcode.png"/>
                      <div class="labelBelowImg">Scan</div>
                    </mu-flexbox-item>
                  </mu-flexbox>
                </mu-content-block>
              </mu-paper>
            </mu-col>
            -->
            <mu-col desktop="50" tablet="50" width="50">
              <mu-paper align="center" class="paperCard">
                <mu-content-block class="landingCard" @click.native="goToSearch">
                  <mu-flexbox align="center" justify="center" style="height: 100%;">
                    <mu-flexbox-item align="center">
                      <img style="height: 58px" src="static/food-diary/search.png"/>
                      <div class="labelBelowImg">{{$t('message.searchText')}}</div>
                    </mu-flexbox-item>
                  </mu-flexbox>
                </mu-content-block>
              </mu-paper>
            </mu-col>
            <mu-col desktop="50" tablet="50" width="50">
              <mu-paper align="center" class="paperCard">
                <mu-content-block class="landingCard" @click.native="goToMyMeals">
                  <mu-flexbox align="center" justify="center" style="height: 100%;">
                    <mu-flexbox-item align="center">
                      <img style="height: 58px" src="static/food-diary/baseline-restaurant_menu-24px.svg"/>
                      <div class="labelBelowImg">{{$t('message.foodDiaryLoadFromMyMeals')}}</div>
                    </mu-flexbox-item>
                  </mu-flexbox>
                </mu-content-block>
              </mu-paper>
            </mu-col>
          </mu-row>
        </mu-col>
        <mu-col desktop="100" tablet="100" width="100">
          <mu-raised-button
            @click.native="copyYesterdaysMeal"
            class="yesterday-btn"
            icon="refresh"
            :label="$t('message.foodDiaryRepeatYesterdayMeal')"
            fullWidth
          >
          </mu-raised-button>
        </mu-col>
        <mu-col desktop="100" tablet="100" width="100" style="margin-top: 16px" v-if="recents.length > 0">
          <mu-card>
            <mu-card-header :title="$t('message.labelRecents')"></mu-card-header>
            <mu-list id="recents">
              <mu-list-item
                v-for="item, index in recents"
                :key="'recent-' + index"
                :title="item.food_name"
                @click.native="selectRecent(item)"
              >
                <mu-icon class="left8" slot="left" value="history"/>
              </mu-list-item>
            </mu-list>
          </mu-card>
        </mu-col>
      </mu-row>
    </mu-content-block>
  </mu-card>
</template>
<script>
  import FoodApi from '../../../api/Food';

  export default {
    props: {
      title: {
        type: String,
        default: "Breakfast"
      },
      mealTypeId: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        recents: []
      }
    },
    mounted: function mounted() {
      let self = this;
      FoodApi.getRecents(self.mealTypeId)
        .then(function (response) {
          self.recents = response.data;
        });
    },
    methods: {
      copyYesterdaysMeal() {
        let self = this;
        FoodApi.copyYesterdaysMeal(self.mealTypeId)
          .then(function (response) {
            self.$emit('closeDialogAndReload');
          })
          .catch(function () {
            let meal;
            switch (self.mealTypeId) {
              case 1:
                meal = self.$t('message.foodDiaryBreakfast');
                break;
              case 2:
                meal = self.$t('message.foodDiaryLunch');
                break;
              case 3:
                meal = self.$t('message.foodDiaryDinner');
              case 4:
                meal = self.$t('message.foodDiarySnack');
                break;
            }
          })
        self.$router.push({
          name: 'FoodDiary'
        })
      },
      goToMyMeals: function goToMyMeals() {
        let self = this;
        self.$router.push({
          name: "FoodDiaryMyMeals",
          query: {
            mealTypeId: self.mealTypeId,
            date: self.$route.query.date,
          },
          params: {
            title: self.title
          }
        })
      },
      selectRecent: function selectRecent(recent) {
        let self = this;
        self.$router.push({
          name: 'FoodDiaryAdd',
          query: {
            foodId: recent.fs_food_id,
            mealTypeId: self.mealTypeId,
            date: self.$route.query.date
          },
          params: {
            title: self.title
          }
        })
      },
      goBack: function goBack() {
        let self = this;
        self.$router.push({name: 'FoodDiary'})
      },
      goToSearch: function goToSearch() {
        let self = this;
        self.$router.push({
          name: 'FoodDiarySearch',
          params: {
            title: self.title,
            mealTypeId: self.mealTypeId,
          },
          query: {
            date: self.$route.query.date,
            mealTypeId: self.$route.query.mealTypeId
          }
        })
      }
    }
  }
</script>
<style scoped>
  .landingCard {
    height: 148px;
  }

  .yesterday-btn {
    height: 54px !important;
  }

  .mu-card-header.headerHasBack .mu-card-header-title {
    padding-left: 16px !important;
  }
</style>
<style>
  .mu-card-header.headerHasBack .mu-card-header-title {
    padding-left: 16px !important;
  }
</style>



// WEBPACK FOOTER //
// Landing.vue?341f1df9